import React from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";
import { WireGuardPageTab } from "./edgeDeviceInterfaces";

const theme = createTheme({
  palette: {
    primary: {
      main: "#FF8400",
    },
  },
});

function a11yProps(index: number) {
  return {
    id: `wireguard-page-tab-${index}`,
    "aria-controls": `wireguard-page-tabpanel-${index}`,
  };
}

const tabSx = {
  fontFamily: "Mulish",
  fontWeight: "Bold",
  color: "primary",
};

export const WireGuardPageTabs = ({
  activeTab,
  setActiveTab,
  showEdgeDevices,
}: {
  activeTab: WireGuardPageTab;
  setActiveTab: Dispatcher<WireGuardPageTab>;
  /** Edge Devices is flag-gated; the other two tabs are always available. */
  showEdgeDevices: boolean;
}) => {
  return (
    <Box
      sx={{ borderBottom: 1, borderColor: "divider", backgroundColor: "white" }}
    >
      <ThemeProvider theme={theme}>
        <Tabs
          value={activeTab}
          onChange={(_, tabValue: WireGuardPageTab) => {
            setActiveTab(tabValue);
          }}
          aria-label="wireguard_page_tabs"
          color="primary"
        >
          <Tab
            value="wireguard-tunnels"
            label="WireGuard Tunnels"
            sx={tabSx}
            {...a11yProps(0)}
          />
          {showEdgeDevices && (
            <Tab
              value="edge-devices"
              label="Edge Devices"
              sx={tabSx}
              {...a11yProps(1)}
            />
          )}
        </Tabs>
      </ThemeProvider>
    </Box>
  );
};
